import { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import classnames from 'classnames';

import { styles } from './styles';
import { CustomSnackBarProps, SUCCESS_SEVERITY } from './interfaces';


export const CustomSnackBar = ({
  showSnackbar,
  title = '¡Listo! La acción se ejecutó con éxito',
  subtitle,
  duration = 6000,
  severity = SUCCESS_SEVERITY,
  verticalAlign = 'bottom',
  horizontalAlign = 'center'
}: CustomSnackBarProps) => {
      const [show, setShow] = useState(showSnackbar);
      const { classes } = styles();

      useEffect(() => {
        setShow(showSnackbar)
      }, [showSnackbar])

      const handleClose = () => {
        setShow(false);
      };

      return (
        <Snackbar open={show} autoHideDuration={duration} onClose={handleClose} anchorOrigin={{ vertical: verticalAlign, horizontal: horizontalAlign }}>
          <Alert onClose={handleClose} severity={severity} className={classnames(classes.alert, { [classes.successAlert]: severity === SUCCESS_SEVERITY })}>
              <div className={classes.title}>{title}</div>
              {subtitle && <div>{subtitle}</div>}
          </Alert>
      </Snackbar>
      );
  }

export default CustomSnackBar;
